export const loanActions = [
  {
    name: 'createLoanRepayments',
    label: 'Loan Repayments',
    args: [
      {
        name: 'interestTypes',
        label: 'Interest Type',
        type: 'dropdown',
        options: [
          { label: 'Simple Interest', value: 'SIMPLE_INTEREST' },
          { label: 'Compound Interest', value: 'COMPOUND_INTEREST' },
        ],
        value: '',
      },
    ],
  },
];
